<template>
  <b-tab title="Items du test">
    <div class="px-2" style="max-width: 100%; overflow-x: hidden;">
      <div
        v-for="(item, idx) in test.items"
        :key="item._localId || idx"
        class="border rounded p-3 mb-4 shadow-sm bg-white"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="item-title">
            {{ item.name && item.name.trim() !== "" ? item.name : "Nouvel item" }}
          </div>
          <b-button variant="danger" size="sm" @click="removeItem(idx)">Supprimer l'item</b-button>
        </div>

        <b-form-group label="Nom de l’item">
          <b-form-input v-model="item.name" />
        </b-form-group>

        <b-form-group :label="'Description de ' + (item.name && item.name.trim() !== '' ? item.name : 'cet item')">
          <b-form-textarea v-model="item.description" rows="2" />
        </b-form-group>

        <b-form-group label="Score max *">
          <b-form-input type="number" min="0" v-model.number="item.scoreMax" />
        </b-form-group>

        <div
          v-for="(question, qIdx) in item.questions"
          :key="qIdx"
          class="mb-3 border rounded p-3 bg-light"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="mb-0">
              {{ question.content && question.content.trim() !== "" ? question.content : "Nouvelle question" }}
            </h6>
            <b-button variant="danger" size="sm" @click="removeQuestion(idx, qIdx)">Supprimer la question</b-button>
          </div>

          <b-form-group label="Nom de la question">
            <b-form-textarea v-model="question.content" rows="2" />
          </b-form-group>

          <b-form-group
            v-if="question.scoresValues && question.scoresValues.length"
            label="Valeurs des choix"
          >
            <div
              v-for="(val, sIdx) in question.scoresValues"
              :key="sIdx"
              class="d-flex align-items-center mb-2"
            >
              <label class="mr-2 mb-0" style="min-width:120px;">
                {{ test.scoresNames[sIdx] }} :
              </label>
              <b-form-input
                v-model="question.scoresValues[sIdx]"
                type="number"
                class="flex-grow-1"
              />
            </div>
          </b-form-group>

          <b-form-group
            v-if="question.choices && question.choices.length"
            :label="'Choix de réponses pour ' + (question.content && question.content.trim() !== '' ? question.content : 'cette question')"
          >
            <div v-for="(choice, cIdx) in question.choices" :key="cIdx" class="input-group mb-2">
              <b-form-input v-model="question.choices[cIdx]" placeholder="Choix" />
              <b-button size="sm" variant="danger" @click="question.choices.splice(cIdx, 1)">Supprimer</b-button>
            </div>
            <b-button size="sm" variant="success" @click="question.choices.push('')">+ Ajouter un choix</b-button>
          </b-form-group>

          <div
            v-if="(!question.scoresValues || !question.scoresValues.length) && (!question.choices || !question.choices.length)"
            class="text-muted small"
          >
            Réponse texte libre
          </div>
        </div>

        <b-button size="sm" variant="primary" class="mt-2" @click="addQuestion(idx)">
          ➕ Ajouter une question
        </b-button>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button size="sm" variant="success" @click="addItem">➕ Ajouter un item</b-button>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="primary" size="lg" @click="saveLocalTest">Enregistrer</b-button>
      </div>
    </div>
  </b-tab>
</template>

<script>
export default {
  name: "TestItems",
  props: {
    test: { type: Object, required: true }
  },
  mounted() {
    if (!this.test.items) this.$set(this.test, 'items', []);
    this.syncScoresValues();
  },
  watch: {
    'test.scoresNames': {
      handler() {
        this.syncScoresValues();
      },
      deep: true
    },
    'test.items': {
      handler() {
      },
      deep: true
    }
  },
  methods: {
    createEmptyQuestion() {
      return {
        content: "",
        choices: [],
        scoresValues: this.test.scoresNames ? this.test.scoresNames.map(() => "") : []
      };
    },
    addItem() {
      if (!this.test.items) this.$set(this.test, "items", []);
      this.test.items.push({
        _localId: `local-${Date.now()}-${Math.floor(Math.random()*1000)}`,
        name: "",
        description: "",
        scoreMax: 0,
        questions: []
      });
    },
    removeItem(idx) {
      this.test.items.splice(idx, 1);
    },
    addQuestion(itemIdx) {
      if (!this.test.items[itemIdx].questions) this.$set(this.test.items[itemIdx], 'questions', []);
      this.test.items[itemIdx].questions.push(this.createEmptyQuestion());
    },
    removeQuestion(itemIdx, qIdx) {
      this.test.items[itemIdx].questions.splice(qIdx, 1);
    },
    syncScoresValues() {
      if (!this.test.items) return;
      const scoreCount = (this.test.scoresNames || []).length;
      this.test.items.forEach(item => {
        item.questions = item.questions || [];
        item.questions.forEach(question => {
          while ((question.scoresValues || []).length < scoreCount) {
            if (!question.scoresValues) question.scoresValues = [];
            question.scoresValues.push("");
          }
          if (question.scoresValues.length > scoreCount) {
            question.scoresValues.splice(scoreCount);
          }
        });
      });
    },
    async saveLocalTest() {
      const testId = this.test._id || this.test.id;
      if (!testId) return;
      try {
        const res = await fetch(`/api/tests/${testId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.test),
        });
        if (res.ok) {
          this.$bvToast?.toast('Modifications enregistrées avec succès', {
            title: 'Succès',
            variant: 'success',
            solid: true
          });
        } else {
          this.$bvToast?.toast('Erreur lors de l\'enregistrement', {
            title: 'Erreur',
            variant: 'danger',
            solid: true
          });
        }
      } catch (e) {
        this.$bvToast?.toast('Erreur réseau ou serveur lors de l\'enregistrement', {
          title: 'Erreur',
          variant: 'danger',
          solid: true
        });
      }
    }
  }
};
</script>

<style scoped>
.item-title {
  background: #f5f7fa;
  border-left: 4px solid #007bff;
  padding: 6px 16px;
  font-size: 1.1rem;
  font-weight: bold;
  color: #222;
  border-radius: 4px 12px 12px 4px;
  margin-bottom: 0;
  display: inline-block;
}
</style>
